export default {
    title: '联创',

    /** 公司名称 */
    name: '珠海联创医疗科技有限公司',
    /** 公司微信 */
    wechat: 'xxxxxxxxxxx',
    /** 公司邮箱 */
    email: 'airsep001@foxmail.com',
    /** 公司手机 */
    phone: 'xxxxxxxxxxx',
    /** 公司电话 */
    tel: '0756-2276320',
    /** 公司电话 */
    tax: '0756-3318330',
    /** 公司地址 */
    address: '珠海市唐家湾镇大学路99号3号厂房',
    /** 备案号 */
    keepOnRecordIcp: '粤ICP备2021111060号',
    
    BDMapInfo: {
        longitude: 113.547825,
        latitude: 22.393319,
        title: '',
        address: '唐家湾镇大学路99号3号厂房（连体厂房）一至五层第二栋第一层1单元'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js